import { Skeleton } from "@/components/shared/Skeleton";

interface TextStyleSkeletonProps {
  count?: number;
}

export function TextStyleSkeleton({ count = 6 }: TextStyleSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`text-style-skeleton-${index + 1}`}
          className="relative overflow-hidden rounded-xl bg-gradient-to-br from-white to-slate-50 border-2 border-slate-200 p-4 h-[80px] flex items-center justify-center"
        >
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0 bg-gradient-to-br from-primary-400 to-accent-400" />
          </div>

          {/* Skeleton text preview */}
          <div className="relative w-full flex flex-col items-center gap-1">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </>
  );
}
